export const COMPLIANCE_DOCUMENTS_OPTIONS = ["CPSC", "GMARK"];
